import { render, staticRenderFns } from "./checkout-dot-com-payment-form.vue?vue&type=template&id=a10a2fa8&scoped=true"
import script from "./checkout-dot-com-payment-form.vue?vue&type=script&lang=js"
export * from "./checkout-dot-com-payment-form.vue?vue&type=script&lang=js"
import style0 from "./checkout-dot-com-payment-form.vue?vue&type=style&index=0&id=a10a2fa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10a2fa8",
  null
  
)

export default component.exports